import React from 'react';
import { connect } from 'react-redux';
import { actions as photoActions, selectPhotoById } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { ChangePhotoVariantMethod } from '../../../thunks/changePhotoVariant';
import { ChangeGroupButtons } from './ChangeGroupButtons';
import styles from './ChangeGroupOverlay.module.scss';

const _ChangeGroupOverlay = ({ photoExists, changeGroup, close }: Props) => {

    if (!photoExists) {
        return null;
    }

    const onSelect = (method: ChangePhotoVariantMethod) => {
        changeGroup(method);
        close();
    };

    return (
        <div className={styles.overlay} onClick={close}>
            <div className={styles.overlayContent}>
                <ChangeGroupButtons onSelect={onSelect} />
            </div>
        </div>
    );
};

type Props = OwnProps & {
    photoExists: boolean;
    changeGroup: (method: ChangePhotoVariantMethod) => void;
};

type OwnProps = {
    groupId: string;
    photoId: string;
    close: () => void;
};

const mapStateToProps = (state: PhotoPrintsPdpState, { photoId, groupId }: OwnProps) => ({
    photoExists: Boolean(selectPhotoById(state, photoId))
});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, { photoId, groupId }: OwnProps) => ({
    changeGroup: (method: ChangePhotoVariantMethod) => {
        if (method === 'move') {
            dispatch(photoActions.move({ photoId, groupId }));
        } else {
            dispatch(photoActions.copy({ photoId, groupId }));
        }
    }
});

export const ChangeGroupOverlay = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ChangeGroupOverlay);